import React from "react";
import { X } from "lucide-react";

const UserProfileModal = ({ isOpen, onClose, user }) => {
  if (!isOpen) return null;

  const fields = [
    { label: "Full Name", value: user.full_name },
    { label: "Email", value: user.email },
    { label: "Mobile No", value: user.mobile_no },
    { label: "Bank Name", value: user.bank_name },
    { label: "Account Number", value: user.account_number },
    { label: "IFSC Code", value: user.ifsc_code },
    { label: "PAN No", value: user.pan_no },
    { label: "Aadhar Number", value: user.adhar_number },
    { label: "UPI ID", value: user.upi_id },
    { label: "Created At", value: new Date(user.createdAt).toLocaleString() },
  ];

  return (
    <div className="userrelses-overlay">
      <div className="userrelses-container">
        <div className="userrelses-header">
          <h2>User Profile — <span>{user.user_id || "Unknown ID"}</span></h2>
          <button onClick={onClose} className="userrelses-close-btn">
            <X size={20} />
          </button>
        </div>

        <div className="userrelses-body">
          {fields.map((field, index) => (
            <div key={index} className="userrelses-row">
              <span className="userrelses-label">{field.label}:</span>
              <span className="userrelses-value">
                {field.value ? field.value : <em>No data</em>}
              </span>
            </div>
          ))}

          {user.pan_card_photo && (
            <div className="userrelses-image-section">
              <p>PAN Card Photo:</p>
              <img
                src={`${process.env.REACT_APP_LINK}${user.pan_card_photo}`}
                alt="PAN Card"
                className="userrelses-image"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProfileModal;
